import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=68e50855&scoped=true&"
import script from "./Relatorio.vue?vue&type=script&lang=js&"
export * from "./Relatorio.vue?vue&type=script&lang=js&"
import style0 from "./Relatorio.vue?vue&type=style&index=0&id=68e50855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e50855",
  null
  
)

export default component.exports